module.exports = "/images/paysafe.png?e01f28de43038484fc3165758b94dc0b";